(ns app.survey.main
  (:require
   [app.survey.event :as survey-events]
   [app.survey.routes :as routes]
   [app.survey.view :as view]
   [cljs.tools.reader.edn :as edn]
   [common.dates :as dates]
   [common.schema.entities.survey.survey-reference-periods :as survey-reference-periods]
   [day8.re-frame.http-fx]
   [frontend.ui.style.theme.core :as theme]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [reagent.dom :as rd]
   [ui.tailwind-theme :as tailwind-theme]
   [ui.window :as window]))

(defn resolve-theme!
  []
  (let [elem (.getElementById js/document "survey-theme")
        classes (.-classList elem)
        tailwind-theme (oops/oget elem "dataset.theme")
        theme-str (->> (range 0 (.-length classes))
                       (map (fn [idx]
                              (.item classes idx)))
                       (first))
        theme (edn/read-string theme-str)]
    (theme/set-theme! theme)
    (tailwind-theme/set-theme! tailwind-theme)))

(defn init!
  []
  (resolve-theme!)
  (routes/start!)
  (dates/initialize-timezone! "Etc/UTC")
  (survey-reference-periods/init-reference-periods)
  (rf/dispatch [::routes/navigate [:loading]])
  (rf/dispatch [::survey-events/load-app-config true])
  (rf/dispatch [::window/track-window-size])

  (rd/render [view/view]
             (.getElementById js/document "zap-application")))

;; hook for shadow-cljs watch (hot code reload)
(defn ^:dev/after-load refresh
  []
  ;;force re-render so changes are immediately visible:
  (rd/render [view/view]
             (.getElementById js/document "zap-application")))
